import styled from "styled-components";

export const Wrap = styled.div`
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 3;
  width: 100%;
  background: #fff;
  box-shadow: 0 -4px 4px -2px rgba(0, 0, 0, 0.08);

  @media (min-width: 990px) {
    position: relative;
    z-index: 2;
    margin-right: -24px;
    margin-left: -24px;
    width: auto;
  }
`;

export const Inner = styled.div`
  padding: 12px 25px;
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;

  a {
    color: var(--color-primary);
    text-decoration: underline;
  }

  &.active {
    color: var(--color-secondary);
    text-align: center;
  }

  &.disabled {
    padding-left: 46px;
  }

  &.inner-bl + .inner-bl {
    padding-top: 0;
  }
`;

export const Button = styled.button`
  position: relative;
  width: 100%;
  background: none;
  border: none;
  background: var(--color-secondary);
  padding: 12px 20px;
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: 0.94px;
  text-transform: uppercase;
  outline: none;
  box-shadow: none;
  cursor: pointer;

  &:focus,
  &:hover,
  &:active {
    outline: none;
    box-shadow: none;
  }

  &:disabled:not(.loading) {
    background-color: #e0e0e0;
    color: #5f645f;
    cursor: default;
  }

  @media (min-width: 990px) {
    margin-right: 0;

    & + button {
      margin-left: 17px;
    }
  }

  @keyframes ld-spin {
    0% {
      animation-timing-function: cubic-bezier(0.5856, 0.0703, 0.4143, 0.9297);
      transform: rotate(0);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  span {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 20px;
    height: 20px;
    margin: -10px;
    opacity: 0;
    z-index: -1;
    transition: all 0.3s;
    transition-timing-function: ease-in;
    animation: ld-spin 1s infinite linear;

    &::after {
      content: " ";
      display: block;
      width: 40px;
      height: 40px;
      box-sizing: border-box;
      border-radius: 50%;
      border: 5px solid #ffffff;
      border-left-color: transparent;
      transform-origin: 0 0;
      transform: translateZ(0) scale(0.5);
      backface-visibility: hidden;
    }
  }

  &.loading {
    span {
      opacity: 1;
      z-index: auto;
      visibility: visible;
    }

    b {
      opacity: 0.3;
    }
  }
`;

export const ChangeButton = styled.button`
  background: none;
  padding: 0;
  border: none;
  color: var(--color-primary);
  outline: none;
  box-shadow: none;
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  cursor: pointer;

  &:focus,
  &:hover,
  &:active {
    outline: none;
    box-shadow: none;
  }

  &:disabled {
    background-color: #e0e0e0;
    color: #5f645f;
    cursor: default;
  }
`;

export const Alert = styled.span`
  position: absolute;
  top: 12px;
  left: 15px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--color-primary);
  border: 1px solid #fff;
  font-size: 14px;
  line-height: 22px;
  color: #fff;
  text-align: center;
`;